import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors, Validators } from '@angular/forms';

@Directive({
  selector: '[appMaxValue]',
  providers: [{provide: NG_VALIDATORS, useExisting: MaxValueDirective, multi: true}]
})
export class MaxValueDirective implements Validator {
  @Input('appMaxValue') valueToCheck: number;

  validate(control: AbstractControl): ValidationErrors {
    return  Validators.max(this.valueToCheck)(control); 
  }
  constructor() { }

}
